/* global BUILD_TYPE */
/* eslint global-require: "off" */
import 'focus-visible';
import 'intersection-observer';

export async function applyPolyfills() {
    if (BUILD_TYPE === 'legacy') {
        require('core-js/es/symbol');
        require('core-js/es/promise/finally');
        require('document-register-element/build/document-register-element');
        require('whatwg-fetch');
    }

    const polyfillsToFetch: Promise<any>[] = [];

    if (polyfillsToFetch.length > 0) {
        await Promise.all(polyfillsToFetch);
    }
}
